import {EmptyCell} from '../../../../../../layout/table/empty-cell/empty-cell';
import {FormattedNumber} from '../../../../../../provider/locale/formatted-number';
import {classNames} from '../../../../../../util/css';
import {PositionChangeEnum, SummaryType} from '../competitors-page-type';

import {DeltaNumber} from './delta-number/delta-number';
import {StatisticsCardTemplateItemType, StatisticsCardType} from './statistics-cards-type';
import * as styles from './statistic-cards.scss';

export function getStatisticCardsConfig(options: {
    data?: SummaryType;
    positionChange: PositionChangeEnum | null;
    onPositionChangeCardClick: (positionChange: PositionChangeEnum) => void;
}): Array<StatisticsCardType> {
    const {data, onPositionChangeCardClick, positionChange} = options;

    const statisticsTemplate: Array<StatisticsCardTemplateItemType> = [
        {
            langKey: 'REVIEWS_ANALYSIS__COMPETITORS__STATISTICS__AVERAGE_POSITION',
            formatOptions: {},
            isInvertColor: true,
            value: data?.avgPosition.current || null,
            delta: data?.avgPosition.delta || null,
        },
        {
            langKey: 'REVIEWS_ANALYSIS__COMPETITORS__STATISTICS__CARD_IMPROVMENT',
            className: classNames(styles.MainStatisticsSingle_card__improved, {
                [styles.MainStatisticsSingle_card__improved__selected]: positionChange === PositionChangeEnum.Improved,
            }),
            formatOptions: {},
            isInvertColor: false,
            onClick: () => onPositionChangeCardClick(PositionChangeEnum.Improved),
            value: data?.cardsImprovedPosition || null,
            delta: null,
        },
        {
            langKey: 'REVIEWS_ANALYSIS__COMPETITORS__STATISTICS__CARD_WORSENING',
            className: classNames(styles.MainStatisticsSingle_card__worsed, {
                [styles.MainStatisticsSingle_card__worsed__selected]: positionChange === PositionChangeEnum.Worsened,
            }),
            formatOptions: {},
            isInvertColor: false,
            onClick: () => onPositionChangeCardClick(PositionChangeEnum.Worsened),
            value: data?.cardsWorsenedPosition || null,
            delta: null,
        },
        {
            langKey: 'REVIEWS_ANALYSIS__COMPETITORS__STATISTICS__GROWTH_POTENTIAL',
            formatOptions: {},
            isInvertColor: false,
            value: data?.potentialGrowthImpressions.current || null,
            delta: data?.potentialGrowthImpressions.delta || null,
        },
        {
            langKey: 'REVIEWS_ANALYSIS__COMPETITORS__STATISTICS__GROWTH_POTENTIAL_CALLS',
            formatOptions: {
                maximumFractionDigits: 0,
            },
            isInvertColor: true,
            value: data?.potentialGrowthCalls || null,
            delta: null,
        },
        {
            langKey: 'REVIEWS_ANALYSIS__COMPETITORS__STATISTICS__GROWTH_POTENTIAL_TRAFFIC',
            formatOptions: {
                maximumFractionDigits: 0,
            },
            isInvertColor: false,
            value: data?.potentialGrowthWebsite || null,
            delta: null,
        },
    ];

    return statisticsTemplate.map((item: StatisticsCardTemplateItemType): StatisticsCardType => {
        const {value, delta, langKey, formatOptions, isInvertColor, className, onClick} = item;

        return {
            langKey,
            value: value !== null ? <FormattedNumber options={formatOptions} value={value} /> : <EmptyCell />,
            delta: delta !== null ? <DeltaNumber delta={delta} invertColor={isInvertColor} /> : <div />,
            deltaValue: delta,
            className,
            onClick,
        };
    });
}
